export default __webpack_public_path__ + "static/media/x-mark.edc27869.jpg";